import { GrandChartStore } from "../../../../stores/grand-charts/grand-chart.store";
import { ButtonToggle, CountLesson, IconArrow, Item } from "./TheCore.styled";
import { getColorByService } from "../../../../styles";
import { ICON_ARROW_RIGHT_COMPONENT } from "../../../../components/common/Icons";
import { MouseEvent, useState } from "react";
import { GrandChartItem } from "../../GrandChartItem/GrandChartItem";

import { boolean } from "boolean";
import { useTranslation } from "react-i18next";

interface TheCoreItemProps {
	grandChartsService: GrandChartStore[];
	isPreCourse?: boolean;
	withoutBorderBottom?: boolean;
	isLast: boolean;
}

export const TheCoreItem = ({ grandChartsService, withoutBorderBottom = false, isLast = false }: TheCoreItemProps) => {
	const { t } = useTranslation();

	// Получаем service_id
	const firstElement = grandChartsService[0];
	const currentIsShow = localStorage.getItem(firstElement?.service?.nameOther);

	const [isShow, setIsShow] = useState(currentIsShow ? boolean(currentIsShow) : true);

	const handleOnToggle = (e: MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation();
		e.preventDefault();

		setIsShow((prevIsShow) => {
			const currentState = !prevIsShow;
			localStorage.setItem(firstElement?.service?.nameOther, String(currentState));
			return currentState;
		});
	};

	return (
		<Item isShow={isShow}>
			<ButtonToggle
				color={getColorByService(firstElement.service.slug)}
				isPreCourse={firstElement.service.isPreService}
				onClick={handleOnToggle}
			>
				<IconArrow>
					<ICON_ARROW_RIGHT_COMPONENT />
				</IconArrow>
				{t(`services.${firstElement?.service.slug}` as any)}
				<CountLesson>
					- {firstElement.count_lesson} {t("titles.lessons")}
				</CountLesson>
			</ButtonToggle>

			{isShow &&
				grandChartsService.map((grandChart, index) => {
					return (
						<GrandChartItem
							key={grandChart.id}
							isPreCourse={firstElement.service.isPreService}
							grandChart={grandChart}
							withoutBorderBottom={withoutBorderBottom || isLast}
						/>
					);
				})}
		</Item>
	);
};
